import { apiFetch } from '../../api/client'
import type { TrustScoreData } from './types'

export async function fetchTrustScore(vendorUserId: number): Promise<TrustScoreData> {
  const res = await apiFetch<{ data: TrustScoreData }>(
    'GET',
    `/api/trust-score/${vendorUserId}`,
  )
  return res.data
}

export async function setTrustOverride(
  vendorUserId: number,
  payload: { score: number; reason: string; initials: string },
): Promise<void> {
  await apiFetch('POST', `/api/trust-score/${vendorUserId}/override`, payload)
}

export async function clearTrustOverride(vendorUserId: number): Promise<void> {
  await apiFetch('DELETE', `/api/trust-score/${vendorUserId}/override`)
}
